import { forwardRef } from "react";
import styles from "./BorderlessButton.module.css";

const BorderlessButton = forwardRef(
  ({ leftIcon, rightIcon, text, onClick, onMouseDown, disabled, className = "" }, ref) => {
    return (
      <button
        className={`${styles.button} ${disabled ? styles.disabled : ""} ${className}`}
        onClick={onClick}
        onMouseDown={onMouseDown}
        ref={ref}
      >
        {leftIcon && leftIcon}
        <span
          style={{
            paddingLeft: `${leftIcon ? "4px" : ""}`,
            paddingRight: `${rightIcon ? "4px" : ""}`,
          }}
        >
          {text}
        </span>
        {rightIcon && rightIcon}
      </button>
    );
  }
);

export default BorderlessButton;
